import { useContext, createContext, FC, ReactNode } from "react";
import { ToastContainer, toast, ToastOptions } from "react-toastify";

type ToastContextType = {
  success: (message: string, options?: ToastOptions) => void
  error: (message: string, options?: ToastOptions) => void
  info: (message: string, options?: ToastOptions) => void
  warning: (message: string, options?: ToastOptions) => void
}

const ToastContext = createContext<ToastContextType | null>(null)

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error("useToast must be used inside ToastProvider");
  }
  return context;
};

export const ToastProvider: FC<{ children: ReactNode }> = ({
  children
}) => {
  const value: ToastContextType = {
    success: (msg, options) => toast.success(msg, options),
    error: (msg, options) => toast.error(msg, options),
    info: (msg, options) => toast.info(msg, options),
    warning: (msg, options) => toast.warning(msg, options),
  }

  return (
    <ToastContext.Provider value={value}>
      {children}
      <ToastContainer
        className='toast-z-index'
        position="bottom-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnHover
        draggable
        theme="colored"
      />
    </ToastContext.Provider>
  )
}
